// Membership tier badges.
//
// This was copy-pasted verbatim into several pages and missing from
// UserProfile, which is why an account profile showed the generic "member"
// role chip where every other view showed SILVER. One copy so a tier added
// here shows up everywhere at once.
import { showsMemberTier, isCourtRenter } from './membership';

export const MEMBER_TAG_STYLES = {
  gold:       { label: 'GOLD',       bg: '#F9E79F', color: '#7E6010' },
  silver:     { label: 'SILVER',     bg: '#E5E8E8', color: '#3F4444' },
  daypass:    { label: 'DAY PASS',   bg: '#D6EAF8', color: '#1B4F72' },
  ambassador: { label: 'AMBASSADOR', bg: '#FADBD8', color: '#922B21' },
  family:     { label: 'FAMILY',     bg: '#E9F7EF', color: '#1E6B3C' },
};

/** Badge style for a tier name, or null if the tier has no badge. */
export function getMemberTagStyle(tierName) {
  if (!tierName) return null;
  const t = String(tierName).toLowerCase().replace(/\s+/g, '');
  if (t.includes('daypass') || t.includes('day-pass')) return MEMBER_TAG_STYLES.daypass;
  if (t.includes('ambassador'))                        return MEMBER_TAG_STYLES.ambassador;
  if (t.includes('family'))                            return MEMBER_TAG_STYLES.family;
  if (t.includes('gold'))                              return MEMBER_TAG_STYLES.gold;
  if (t.includes('silver'))                            return MEMBER_TAG_STYLES.silver;
  return null;
}

/**
 * Chip config for a person. Renders every role, but when a tier badge will
 * show (member in good standing, tier matching a known style) the generic
 * 'member' role chip is dropped in favour of the tier-specific one.
 */
export function getRoleChipsConfig(person) {
  const roles = Array.isArray(person?.roles) ? person.roles : [];
  // A court renter shows no membership badge and no "Member" chip. Without this
  // a renter picks the generic chip back up the moment their 'member' role is
  // removed, since the chip is driven by the membership map rather than by the
  // role. A renter who also holds a real Silver or Gold membership is not a
  // renter by this test and keeps their badge.
  const isRenter = isCourtRenter(person);
  const tierStyle = !isRenter && showsMemberTier(person)
    ? getMemberTagStyle(person?.membership?.tierName)
    : null;
  const isMemberActive = !isRenter && showsMemberTier(person) && person?.membership?.tierId;
  const filteredRoles = tierStyle ? roles.filter(r => r !== 'member') : roles;
  return { roles: filteredRoles, tierStyle, isMemberActive };
}
